import { Form, Input, InputType } from "decorator-form";

import { ID } from "common/entities/IEntity";
import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import { registerWidget } from "common/form/register";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import IOption from "common/models/IOption";
import Featured from "./entities/Featured";
import * as featuredFragments from "./displayFragments";
import { FragmentProvider } from "core/components/FragmentProvider";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "../../core/components/FragmentLayout";
import * as displayFragments from "../catalog/fragments/course/displayFragments"
import * as actionFragments from "../catalog/fragments/course/actionFragments";


const courseFragmentsInput = FragmentProvider.getLayoutInput({
	...displayFragments,
	...actionFragments,
	...featuredFragments
});


const FeaturedsSelect = EntityMultiSelect.registered(Featured , {pageSize: 400}, {valueKey: "id", nameKey: "entry.product.name"});

export enum ListTypeOptions {
	NONE = "none",
	ROWS = "rows",
	CAROUSEL = "carousel"
}
const listTypeOptions: IOption[] = [
	{ value: ListTypeOptions.NONE, label: "List" },
	{ value: ListTypeOptions.ROWS, label: "Responsive Rows" },
	{ value: ListTypeOptions.CAROUSEL, label: "Carousel" }
];
const listTypeInput = registerWidget(ButtonSelect.withOptions(listTypeOptions), "string");

@Form({title: "FeaturedItems Panel Config"})
export class FeaturedItemsPanelConfig {

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number = 5;

	@Input({type: InputType.TEXT, title: "Header Text"})
	public title: string;

	@Input({type: InputType.TEXT, title: "Sub Title"})
		public subTitle: string;

	@Input({type: listTypeInput, title: "View Type"})
	public view: ListTypeOptions;

	@Input({type: InputType.CHECKBOX, title: "Show Custom Featured Items"})
	public showCustFI?: boolean = false;

	@Input({type: FeaturedsSelect, title: "Featured Items (works only if custom features are enabled)"})
	public featuredIds: ID[];

	@Input({
		type: courseFragmentsInput,
		title: "Course Layout"
	})
	public courseFragmentsLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: InputType.TEXT, title: "Show Custom fields"})
	public showCustomFields: string;

}



// WEBPACK FOOTER //
// ./src/panels/featuredItems/FeaturedItemsPanelConfig.ts